import { UserData, useCurrentUser } from '@bizzabo/entities';
import { createContext, FC, useMemo } from 'react';
import useContextWithWithErrorWrapper from 'hooks/useContextWithErrorWrapper';
import useEventId from 'hooks/useEventId';

type CurrentUserContextType = { user: UserData; isLoading: boolean; error: Error } | undefined;

export const CurrentUserContext = createContext<CurrentUserContextType>(undefined);

export const CurrentUserProvider: FC = ({ children }) => {
    const eventId = useEventId();
    const { data: currentUser, isLoading, error } = useCurrentUser(eventId);

    const currentUserCtx = useMemo(
        () => ({ user: currentUser, isLoading, error }),
        [currentUser, isLoading, error]
    );

    return (
        <CurrentUserContext.Provider value={currentUserCtx}>{children}</CurrentUserContext.Provider>
    );
};

export const useCurrentUserContext = () =>
    useContextWithWithErrorWrapper<CurrentUserContextType>(
        CurrentUserContext,
        'CurrentUserContext'
    );

export default CurrentUserContext;
